import { t } from '../../../../../../common/i18n.js'
import type { Language } from '../../../../../../common/types/i18n.js'
import type { TeamWorkloadPayload } from '../../../../../../server/controllers/portal/dashboard-card-payloads.js'
import '../../../../../components/portal-absence-badge/portal-absence-badge.css'
import { PortalAbsenceBadge } from '../../../../../components/portal-absence-badge/portal-absence-badge.js'
import { formatDateRangeShort } from '../../../utils/format.js'
import './my-team-time-away-card.css'

export const TeamWorkloadCard = ({ data, lang }: { data: TeamWorkloadPayload; lang: Language }) => {
    const c = t.portal.dashboard.cards.team_workload

    if (data.status === 'no_team') {
        return (
            <>
                <span className="portal-card__value">{c.empty(lang)}</span>
                <span
                    className="portal-card__subtext"
                    style={{ color: 'var(--portal-text-muted)' }}
                >
                    {c.noTeam(lang)}
                </span>
            </>
        )
    }

    const available = data.activeMembers - data.awayMembers

    return (
        <>
            <span className="portal-card__value">
                {`${Math.round(data.availablePercent * 100)}%`}
            </span>
            <span className="portal-card__subtext">
                {c.available(available, data.activeMembers)(lang)}
            </span>
            <span className="portal-card__subtext">
                {c.summedFte(Math.round(data.summedFte * 10) / 10)(lang)}
            </span>

            <hr className="portal-card__divider portal-card__divider--inner" />

            <span className="portal-card__label">{c.currentHeading(lang)}</span>
            {data.currentlyAway.length === 0 ? (
                <div className="portal-team-away-card__empty">{c.currentEmpty(lang)}</div>
            ) : (
                <div className="portal-team-away-card__list">
                    {data.currentlyAway.map((entry) => (
                        <div key={entry.employeeId} className="portal-team-away-card__row">
                            <div className="portal-team-away-card__name">
                                {entry.firstName} {entry.lastName}
                            </div>
                            <PortalAbsenceBadge
                                badgeType={entry.badgeType}
                                label={entry.leaveType}
                            />
                        </div>
                    ))}
                </div>
            )}

            <span className="portal-card__label">{c.upcomingHeading(lang)}</span>
            {data.upcoming.length === 0 ? (
                <div className="portal-team-away-card__empty">{c.upcomingEmpty(lang)}</div>
            ) : (
                <div className="portal-team-away-card__list">
                    {data.upcoming.map((entry, idx) => (
                        <div
                            key={`${entry.employeeId}-${entry.startDate}-${idx}`}
                            className="portal-team-away-card__row"
                        >
                            <div className="portal-team-away-card__name">
                                {entry.firstName} {entry.lastName}
                            </div>
                            <PortalAbsenceBadge
                                badgeType={entry.badgeType}
                                label={entry.leaveType}
                            />
                            <span className="portal-team-away-card__count">
                                {formatDateRangeShort(entry.startDate, entry.endDate)} ·{' '}
                                {c.daysCount(entry.dayCount)(lang)}
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </>
    )
}
